import { ButtonGroup, FormGroup, Label, Switch } from "@xola/ui-kit";
import { FieldProps, Field as FormikField } from "formik";
import { capitalize } from "lodash";
import React from "react";
import { HeightUnit, WeightUnit } from "types";
import { HeightFeetDisplayValue } from "../../../Questionnaire/HeightField";
import { QuestionnaireModalType } from "@/models/Form/QuestionnaireModalType";

export const UnitMeasurementField = ({ modalType }: { modalType: QuestionnaireModalType }) => {
    if (![QuestionnaireModalType.WEIGHT, QuestionnaireModalType.HEIGHT].includes(modalType)) {
        return null;
    }

    const options: string[] =
        modalType === QuestionnaireModalType.WEIGHT
            ? [WeightUnit.KG, WeightUnit.LBS]
            : [HeightUnit.CM, HeightUnit.FEET];

    const secondOption = modalType === QuestionnaireModalType.HEIGHT ? HeightFeetDisplayValue : options[1];

    return (
        <FormGroup>
            <Label>Unit of Measurement</Label>
            <div className="flex justify-between">
                <FormikField name="unit">
                    {({ field: { value }, form }: FieldProps) => {
                        const currentValue = options.indexOf(value);
                        return (
                            <ButtonGroup
                                size="medium"
                                value={currentValue}
                                data-testid="unit-management-option"
                                onChange={(index: number) => form.setFieldValue("unit", options[index])}
                            >
                                <ButtonGroup.Button type="button">{capitalize(options[0])}</ButtonGroup.Button>
                                <ButtonGroup.Button type="button">{capitalize(secondOption)}</ButtonGroup.Button>
                            </ButtonGroup>
                        );
                    }}
                </FormikField>

                {modalType === QuestionnaireModalType.WEIGHT && (
                    <FormikField name="summation">
                        {({ field: { value }, form }: FieldProps) => {
                            return (
                                <Switch.Group>
                                    <Switch
                                        data-testid="summation-toggle"
                                        isChecked={value}
                                        onChange={(value: boolean) => form.setFieldValue("summation", value)}
                                    />
                                    <Switch.Label className="ml-3">Sum Total Weights</Switch.Label>
                                </Switch.Group>
                            );
                        }}
                    </FormikField>
                )}
            </div>
        </FormGroup>
    );
};
